import React from 'react';
import { getGroupsList } from '../../../../models/groups';
import i18n from '../../../../i18n';
import { formatDate, getAvatarColor, getInitials } from '../../../../utils/common';
import HeaderBanner from '../../../common/HeaderBanner';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Select from 'react-select';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import NoData from '../../../common/NoData';
import { getOrganizationList } from '../../../../models/organization';
import { ArrowLeft } from 'lucide-react';
import { withRouter } from '../../../../hoc/withRouter';
import { getWinners } from './services/managementService';
import { getLoggedUser } from '../../../../state/user';

const user = getLoggedUser();

class WinnerList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: null,
        group: null,
      },
      clients: [],
      groups: [],
      winners: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
      bidders: [],
      startDate: null,
      endDate: null,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      client: params.get('client') || null,
      group: params.get('group') || null,
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;
    const startDate = params.get('startDate') || null;
    const endDate = params.get('endDate') || null;

    this.setState({ search, page, limit, startDate, endDate }, () => {
      this.getAllOrganization();
      this.getAllWinners();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getAllWinners() {
    this.setState({ isloading: true });
    let { limit, page, startDate, endDate } = this.state;
    let { client, group } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (client) q.client = client;
    if (group) q.group = group;
    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;

    // Update URL
    this.updateUrlQuery(q);

    try {
      const response = await getWinners(q);
      if (response.success) {
        this.setState({
          winners: response.data,
          total: response.meta.total,
        });
      }
    } catch (error) {
      console.error('Auction fetch failed:', error);
    } finally {
      this.setState({ isloading: false });
    }
  }

  async getAllOrganization() {
    const response = await getOrganizationList();
    let data = response.data;
    const clients = data.map((item) => {
      return {
        value: item.id,
        label: item.organization_name,
      };
    });
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ grouploading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let data = response.data;
      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups, groupLoading: false });
    } else {
      this.setState({ groups: [], grouploading: false });
    }
  }

  getColumns = () => {
    return [
      {
        name: i18n.t('bidder'),
        width: '100px',
        wrap: true,
        cell: (row) => (
          <div className="bidder-avatar" style={{ backgroundColor: getAvatarColor(row.user_id) }}>
            {getInitials(row.user?.name)}
          </div>
        ),
      },
      {
        minWidth: '140px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">{row.user?.name || '--'}</span>
        ),
      },

      {
        name: i18n.t('bidder_email'),
        minWidth: '140px',
        cell: (row) => <span>{row.user?.email || '--'}</span>,
      },
      {
        name: i18n.t('auction_name'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">{row.auction?.title || '--'}</span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('group_name'),
        width: '130px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">{row.group?.group_name || '--'}</span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('client_name'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">
            {row.auction?.organization_relation.organization_name || '--'}
          </span>
        ),
        wrap: true,
      },
      {
        name: i18n.t('bid_amount'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value-secondary">{row.bid_amount}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('bid_at'),
        cell: (row) => <span>{formatDate(row.created_at)}</span>,
        wrap: true,
      },
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = {
          ...prevState.search,
          [name]: value,
          // Clear group when client changes or is cleared
          ...(name === 'client' && { group: null }),
        };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client' && value) {
          // Only load if client has value
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getAllWinners();
  };

  handleClear = () => {
    const defaultSearch = {
      client: null,
      group: null,
    };

    this.setState({ search: defaultSearch, page: 1 }, () => {
      this.getAllWinners();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getAllWinners();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getAllWinners();
    });
  };

  render() {
    const { groups, winners, clients } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('winners')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                    <button
                      className="button1 button1-gradient button1-back"
                      onClick={() =>
                        this.props.navigate(user.role === 'C' ? '/client-dashboard' : '/management')
                      }
                    >
                      <ArrowLeft size={18} className="icon" />
                      <span>Back</span>
                    </button>
                  </div>
                  <div className="card-body">
                    {user.role !== 'C' && (
                      <FilterSection
                        loading={this.state.isloading}
                        onSearch={this.handleSearch}
                        onClear={this.handleClear}
                      >
                        {/* Client Dropdown */}
                        <div className="react-select-wrapper">
                          <Select
                            options={clients}
                            value={
                              clients.find((c) => c.value === this.state.search.client) || null
                            }
                            onChange={(selectedOption) => {
                              const clientValue = selectedOption ? selectedOption.value : null;
                              this.setState(
                                (prevState) => ({
                                  search: {
                                    ...prevState.search,
                                    client: clientValue,
                                    group: null,
                                  },
                                  groups: [],
                                }),
                                () => {
                                  if (clientValue) {
                                    this.getAllGroups();
                                  }
                                }
                              );
                            }}
                            name="client"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={i18n.t('select_client')}
                            className=""
                          />
                          {/* Only show label when there's a selected value */}

                          <label className="react-select-label">{i18n.t('client_name')}</label>
                        </div>

                        {/* Group Dropdown */}
                        <div className="react-select-wrapper">
                          <Select
                            options={groups}
                            value={groups.find((c) => c.value === this.state.search.group) || null}
                            onChange={(selectedOption) => {
                              this.setState((prevState) => ({
                                search: {
                                  ...prevState.search,
                                  group: selectedOption ? selectedOption.value : null,
                                },
                              }));
                            }}
                            name="group"
                            styles={selectStyles}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            placeholder={i18n.t('search_group')}
                            isLoading={this.state.groupLoading}
                            isDisabled={this.state.groupLoading}
                            className=""
                          />
                          {/* Only show label when there's a selected value */}

                          <label className="react-select-label">{i18n.t('group')}</label>
                        </div>
                      </FilterSection>
                    )}

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={7} rows={7} />
                      ) : this.state.winners.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={winners}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_winners_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.getAllWinners.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default withRouter(WinnerList);
